var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"error"},[_c('div',{staticClass:"basicWrap clear"},[_c('div',{staticClass:"error__tit"},[_c('span',[_vm._v("ERROR 404")]),_c('h2',[_vm._v("페이지를 찾을 수 없습니다.")]),_c('p',[_vm._v("페이지가 존재하지 않거나, 사용할 수 없는 페이지입니다.")]),_c('router-link',{attrs:{"to":"/"}},[_vm._v("메인으로 가기")])],1),_c('div',{staticClass:"error__img"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }